import * as React from "react";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { formatDate, formatCurrencyWithRands } from "app/utils/filters";
import AllCashbackStrategiesContainer from "./AllCashbackStrategiesContainer";

export type CashbackStrategy = {
  id: number;
  type: string;
  description: string;
  value: number;
  updated_at: string;
  maximum_cashback_per_payment: number;
  maximum_total_payout: number;
  minimum_payment_amount: number;
  user_limit_amount: number;
  user_limit_type: string;
  strategy_limit_amount: number;
};

export type QrCode = {
  code: string;
};

type Props = {
  card: {
    id: number;
    store_name: string;
    cashback_strategy: CashbackStrategy;
    qr_codes: Array<QrCode>;
  };
  urls: {
    snapmin_create_fixed_url: string;
    snapmin_create_percentage_url: string;
  };
  editCard: (variables: any) => Promise<void>;
  fetchCardCashbackStrategies: () => void;
};

type State = {
  browseStrategies: boolean;
};

export const formatValue = (strategy: CashbackStrategy): string => {
  switch (strategy.type) {
    case "PercentageCashbackStrategy":
      return strategy.value + "%";
    case "FixedCashbackStrategy":
      return formatCurrencyWithRands(strategy.value);
    default:
      return strategy.value + "";
  }
};

export default class CardCashbackStrategyContainer extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      browseStrategies: false,
    };
  }

  flipTable(): void {
    this.setState({ browseStrategies: !this.state.browseStrategies });
  }

  removeStrategy(): void {
    this.props
      .editCard({
        variables: {
          id: this.props.card.id,
          cashback_strategy_id: "",
        },
      })
      .then(() => {
        this.props.fetchCardCashbackStrategies();
      });
  }

  renderCashbackStrategy(strategy: CashbackStrategy): any {
    return (
      <div>
        <div
          className="half-parent"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            paddingTop: "10px",
            width: "100%",
          }}
        >
          <div>
            <b>Type: </b> {strategy.type}
          </div>
          <div>
            <b>Value: </b> {formatValue(strategy)}
          </div>
          <div>
            <b>Last Updated: </b> {formatDate(strategy.updated_at)}
          </div>
          <div>
            <b>Description: </b> {strategy.description}
          </div>
          <div>
            <b>Maximum cashback earnable per transaction: </b>
            {formatCurrencyWithRands(strategy.maximum_cashback_per_payment)}
          </div>
          <div>
            <b>Maximum total payout for Card: </b>
            {formatCurrencyWithRands(strategy.maximum_total_payout)}
          </div>
          <div>
            <b>Minimum amount to qualify for cashback: </b>
            {formatCurrencyWithRands(strategy.minimum_payment_amount)}
          </div>
          <div>
            <b>User limit type: </b> {strategy.user_limit_type}
          </div>
          <div>
            <b>User limit amount: </b>
            {formatCurrencyWithRands(strategy.user_limit_amount)}
          </div>
          <div>
            <b>Strategy limit amount: </b>
            {formatCurrencyWithRands(strategy.strategy_limit_amount)}
          </div>
        </div>
        <Button
          color="primary"
          onClick={() => {
            this.flipTable();
          }}
        >
          {this.state.browseStrategies ? "Done" : "Change"}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            this.removeStrategy();
          }}
        >
          Remove
        </Button>
        {this.renderFindStrategy()}
      </div>
    );
  }

  renderNoStrategy(): any {
    return (
      <div>
        <Button
          color="primary"
          onClick={() => {
            this.flipTable();
          }}
        >
          {this.state.browseStrategies ? "Done" : "Set"}
        </Button>
        {this.renderFindStrategy()}
      </div>
    );
  }

  renderFindStrategy(): any {
    const strategy = this.props.card.cashback_strategy;
    return this.state.browseStrategies ? (
      <div>
        <AllCashbackStrategiesContainer
          name={"ops.merchants.cashbackstrategies.list"}
          cardId={this.props.card.id}
          currentStrategyId={strategy ? strategy.id : null}
          editCard={this.props.editCard}
          fetchCardCashbackStrategies={this.props.fetchCardCashbackStrategies}
        />
        <a
          style={{ marginRight: "10px" }}
          className="blueLink"
          href={this.props.urls.snapmin_create_fixed_url}
        >
          New Fixed Strategy
        </a>
        <a
          style={{ marginRight: "10px" }}
          className="blueLink"
          href={this.props.urls.snapmin_create_percentage_url}
        >
          New Percentage Strategy
        </a>
      </div>
    ) : null;
  }

  render(): any {
    const card = this.props.card;
    return (
      <Paper
        style={{
          margin: "10px",
          padding: "10px",
          display: "inline-block",
          width: "calc(100% - 20px)",
        }}
      >
        <h4
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            paddingBottom: "10px",
            fontWeight: 100,
          }}
        >
          <div><b>Card ID:</b> {card.id}</div>
          <div><b>Store Name:</b> {card.store_name}</div>
          <div style={{display: 'flex', flexDirection: 'row'}}><b>QR Codes: </b> {card.qr_codes.map((item, index) => {
              return <div key={index}> { item.code }{index + 1 >= card.qr_codes.length ? '' : ', '}</div>
          })}</div>
        </h4>
        {card.cashback_strategy
          ? this.renderCashbackStrategy(card.cashback_strategy)
          : this.renderNoStrategy()}
      </Paper>
    );
  }
}
